import { createSlice } from '@reduxjs/toolkit';
import api from './api';
import { ReducerWorksheets } from './types';

export const GET_WORKSHEETS = (params) => async (dispatch) => {
  const res = await api.getWorksheets(params)
  dispatch({ type: ReducerWorksheets.SET_WORKSHEETS, data: res.data, meta: res })
}

export const GET_WORKSHEET_BY_ID = (id) => async (dispatch) => {
  const res = await api.getWorksheetById(id)
  dispatch({ type: ReducerWorksheets.SET_WORKSHEET, data: res.data })
  return res.data
}

export const GET_WORKSHEETS_BY_USER_ID = (id) => async (dispatch) => {
  const res = await api.getWorksheetsByUserId(id)
  dispatch({ type: ReducerWorksheets.SET_WORKSHEETS_USER, data: res.data })
  return res.data
}

export const CREATE_WORKSHEET = (formData) => async (dispatch) => {
  const res = await api.createWorksheet(formData)
  return res.data
}

export const UPDATE_WORKSHEET = (id, formData) => async (dispatch) => {
  const res = await api.updateWorksheet(id, formData)
  return res.data
}

export const DELETE_WORKSHEET = (id) => async (dispatch) => {
  const res = await api.deleteWorksheet(id)
  return res.data
}

export const UPDATE_WORKSHEET_BY_USER = (body) => async (dispatch) => {
  const res = await api.updateUsersWorksheet(body)
  return res.data
}

const worksheetsReducer = createSlice({
  name: 'worksheets',
  initialState: {
    lists: [],
    listsUser: [],
    worksheet: {}
  },
  extraReducers: {
    [ReducerWorksheets.SET_WORKSHEETS]: (state, action) => {
      state.lists = action.data
      state.meta = action.meta
    },
    [ReducerWorksheets.SET_WORKSHEETS_USER]: (state, action) => {
      state.listsUser = action.data
    },
    [ReducerWorksheets.SET_WORKSHEET]: (state, action) => {
      state.worksheet = action.data
    }
  },
})

const { reducer } = worksheetsReducer
export default reducer
